import {Paper} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {reverse} from 'named-urls';
import React, {useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';
import Contacts from '../Contacts/Table';

const useStyles = makeStyles((theme) => ({
  container: {
    '&.MuiPaper-root': {
      overflow: 'hidden',
      marginTop: theme.spacing(1),
    }
  }
}));

const Tabs = ({material}) => {
  const classes = useStyles();
  const match = useRouteMatch();
  const [tab, setTab] = useState('');

  const tabs = useMemo(() => [
    {
      title: 'Contacts',
      slug: '',
      path: reverse(material.archived ? routes.archive.material.detail : routes.materials.detail, {
        id: material?.id ?? 0
      })
    }
  ], [material]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    }
  }, [material, match, tabs])

  return (
    <>
      <Switcher tabs={tabs}/>
      <Paper className={classes.container}>
        <Switched tab="" currentTab={tab}>
          <Contacts byMaterial={material}/>
        </Switched>
      </Paper>
    </>
  );
};

export default Tabs;
